<template>
  <div class=" ">

   <v-card class="p-3" style="min-height: 140px;" shaped elevation="10">
    <h2 class="text-md md:text-base text-neutral-600">   Alvara Renovação </h2>
    
    <span
      class=" text-sm absolute whitespace-no-wrap text-neutral-500  bottom-0 m-3 left-0"
      style="">
        {{ moment().locale('pt-br').format('MMM [de] YYYY') }}
    </span>
    <div>
    </div>

    <v-row class="mt-1">
      <v-col v-for="(alvara,index) in alvara_renovacao"  :key="index" md="6" cols="12">
    <div class="text-center">
      <div class="font-light text-neutral-600">{{ index }}</div>
      <div class="font-bold text-primary-600 text-lg">{{ alvara }}</div>
    </div>
  </v-col>


  </v-row>
  </v-card>
  </div>
</template>

<script>
import { AlvaraRenovacaoRequest } from "@/services/requests/charts";
import moment from "moment";

export default {
  name: "AlvaraRenovacaoStatus",
  data() {
    return {
      header: {
        title: "Alvara Renovação",
        icon: "Document",
      },
      loading: true,
      alvara_renovacao: [],
      label: [],
      isValor:true
    };
  },
  methods: {
    moment,
    fetchResults() {
      this.loading = true;
      AlvaraRenovacaoRequest()
        .then((res) => {
          console.log(res.data);
          this.alvara_renovacao = res.data;
        })
        .finally(() => (this.loading = false));
    },
  },
  beforeMount() {
    this.fetchResults();
  },
};
</script>
